/**
 * Formato de fecha/hora en estilo ISO 8601 (hora local): "YYYY-MM-DD HH:mm".
 * Usa el locale sv-SE, que rinde el patrón ISO de forma nativa.
 */
export function formatFechaHoraIso(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** Solo la fecha en ISO (hora local): "YYYY-MM-DD".
 *  Uso interno (filtros/comparaciones) · para MOSTRAR usa `formatFecha`. */
export function formatFechaIso(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("sv-SE");
}

/** Fecha para MOSTRAR al usuario · "dd/MM/yyyy". Seguro para fechas "solo fecha"
 *  ("YYYY-MM-DD") · las formatea sin corrimiento de zona horaria. */
export function formatFecha(iso: string | null | undefined): string {
  if (!iso) return "—";
  const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (soloFecha) return `${soloFecha[3]}/${soloFecha[2]}/${soloFecha[1]}`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/** Fecha y hora para MOSTRAR al usuario · "dd/MM/yyyy HH:mm" (24h, hora local). */
export function formatFechaHora(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const fecha = d.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const hora = d.toLocaleTimeString("es-MX", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${fecha} ${hora}`;
}
